import { useSyncExternalStore } from "react";

const emptySubscribe = () => () => {};
const returnTrue = () => true;
const returnFalse = () => false;

/**
 * Whether this render is on the client, after hydration.
 *
 * @returns false on the server and during hydration, true afterwards.
 */
export function useIsClient(): boolean {
  return useSyncExternalStore(emptySubscribe, returnTrue, returnFalse);
}
